import { render } from "./SuperAdminAproveUser.vue?vue&type=template&id=2f08143e&scoped=true"
import script from "./SuperAdminAproveUser.vue?vue&type=script&lang=js"
export * from "./SuperAdminAproveUser.vue?vue&type=script&lang=js"

import "./SuperAdminAproveUser.vue?vue&type=style&index=0&id=2f08143e&scoped=true&lang=css"
import "./SuperAdminAproveUser.vue?vue&type=style&index=1&id=2f08143e&lang=css"
import "./SuperAdminAproveUser.vue?vue&type=style&index=2&id=2f08143e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f08143e"]])

export default __exports__